import { useState } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import DDMNavBar from '@/externals/ddm/components/DDMNavBar';
import { DialogContainer } from '@/modules/MuiDialog';
import type { DmAutomationDto } from '@/types/dmAutomation';
import AutoDmSidebar, { type DmSection } from './Sidebar';
import AutoDmRoot, { type AutoDmView } from '@/pages/AutoDm';

const AutoDmLayout = () => {
    const [appBarHeight, setAppBarHeight] = useState(64);
    const [section, setSection] = useState<DmSection>('list');
    const [view, setView] = useState<AutoDmView>('list');
    const [editing, setEditing] = useState<DmAutomationDto | null>(null);

    const handleChangeSection = (next: DmSection) => {
        setSection(next);
        setView('list');
        setEditing(null);
    };

    const handleCreate = () => {
        setSection('list');
        setView('wizard');
        setEditing(null);
    };

    const handleStartEdit = (automation: DmAutomationDto) => {
        setSection('list');
        setEditing(automation);
        setView('wizard');
    };

    const handleExitWizard = () => {
        setView('list');
        setEditing(null);
    };

    return (
        <>
            <Helmet>
                <title>자동DM · FLOWING SPACE</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    '--app-bar-height': `${appBarHeight}px`,
                }}
            >
                <DDMNavBar setAppBarHeight={setAppBarHeight} />

                <Box
                    sx={{
                        display: 'flex',
                        flexGrow: 1,
                        minHeight: `calc(100vh - ${appBarHeight}px)`,
                        bgcolor: '#f4f5f7',
                    }}
                >
                    <AutoDmSidebar active={section} onChange={handleChangeSection} onCreate={handleCreate} />

                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            minWidth: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <AutoDmRoot
                            section={section}
                            view={view}
                            editing={editing}
                            onChangeView={setView}
                            onChangeSection={setSection}
                            onStartEdit={handleStartEdit}
                            onExitWizard={handleExitWizard}
                        />
                    </Box>
                </Box>
            </Box>

            <DialogContainer />
        </>
    );
};

export default AutoDmLayout;
